import { Injectable, OnInit } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
//import { ItalianCities } from 'app/theme/assets/data/italian.cities';
import { RequestService } from './request.service';
import { IListLKMetodoPreferitoResponse, IListLKPdvResponse, IListLKCountryResponse, IListMFAResponse } from '../models/response';

@Injectable()
export class DataService implements OnInit {
    country: BehaviorSubject<any> = new BehaviorSubject(null);
    province: BehaviorSubject<any> = new BehaviorSubject(null);
    pdv: BehaviorSubject<any> = new BehaviorSubject(null);
    mfa: BehaviorSubject<any> = new BehaviorSubject(null);
    metodoPreferito: BehaviorSubject<any> = new BehaviorSubject(null);
    italianCities: BehaviorSubject<any> = new BehaviorSubject(null);
    italianCitiesProvince: BehaviorSubject<any> = new BehaviorSubject(null);
    attempt: number;
    MUXCountry: boolean;
    MUXProvice: boolean;
    MUXPdv: boolean;
    MUXMfa: boolean;
    MUXItalianCities: boolean;
    MUXMetodoPreferito: boolean;
    constructor(
        protected _requestService: RequestService
    ) {
        this.ngOnInit();
    }

    ngOnInit() {
        this.attempt = 0;
        this.MUXCountry = true;
        this.MUXItalianCities = true;
        this.MUXMetodoPreferito = true;
        this.MUXPdv = true;
        this.MUXProvice = true;
        this.MUXMfa = true;
    }

    GetListLKCountry(): Observable<any> {
        if (!this.country.getValue())
            if (this.MUXCountry) {
                this.MUXCountry = false;
                this._requestService.makeRequest('rest/internal/getListLKCountry', {},
                    (data: IListLKCountryResponse) => {
                        this.country.next(data.list);

                    },
                    () => {
                        this.attempt++;
                        this.MUXCountry = true;
                        if (this.attempt < 10)
                            this.GetListLKCountry();
                    },
                    null,
                    false,
                    null,
                    100000,
                    true,
                    false)
            }
        return this.country.asObservable();
    }

    GetListMFAuth(): Observable<any> {
        if (!this.mfa.getValue())
            if (this.MUXMfa) {
                this.MUXMfa = false;
                this._requestService.makeRequest('rest/internal/getListMFAuth', {},
                  (data: IListMFAResponse) => {
                      this.mfa.next(data.list);
                },
                () => {
                    this.attempt++;
                    this.MUXMfa = true;
                    if (this.attempt < 10)
                        this.GetListMFAuth();
                },
                    null,
                    false,
                    null,
                    100000,
                    true,
                    false)
            }
        return this.mfa.asObservable();
    }

    GetListProvincia(country = "ITA"): Observable<any> {
        if (!this.province.getValue())
            if (this.MUXProvice) {
                this.MUXProvice = false;
                this._requestService.makeRequest('rest/internal/getListLKProvincia', {},
                    (data) => {
                        var filteredProv = data.listProvincia.filter(prov => prov.codeProvincia.includes(country));
                        filteredProv = filteredProv.sort((p1, p2) => p1.descriptionProvincia > p2.descriptionProvincia);
                        this.province.next(filteredProv);
                    }, () => {
                        this.attempt++;
                        this.MUXProvice = true;
                        if (this.attempt < 10)
                            this.GetListProvincia(country);
                    },
                    null,
                    false,
                    null,
                    100000,
                    true,
                    false)
            }
        return this.province.asObservable();
    }

    /*GetItalianCities(): Observable<any> {
        if (this.MUXItalianCities) {
            this.MUXItalianCities = false;
            if (!this.italianCities.getValue()) {
                var italianCities: Array<any> = [];
                var prov = ItalianCities[0];
                for (var index in prov)
                    for (var city of prov[index])
                        italianCities.push(city)
                this.italianCities.next(italianCities)
                this.MUXItalianCities = true;

            } else
                this.MUXItalianCities = true;
        }
        return this.italianCities.asObservable();
    }*/
    GetItalianCities(): Observable<any> {
        if (this.MUXItalianCities) {
            this.MUXItalianCities = false;
            if (!this.italianCities.getValue()) {
                var italianCities: Array<any> = [];
                this._requestService.makeRequest('assets/data/italian.cities.json', {}
                    , (ItalianCities) => {
                        var prov = ItalianCities[0];
                        for (var index in prov)
                            for (var city of prov[index])
                                italianCities.push(city)
                        this.italianCities.next(italianCities)
                        this.MUXItalianCities = true;
                    },
                    (err) => {
                        this.MUXItalianCities = true;
                    },
                    null,
                    false,
                    null,
                    100000,
                    true,
                    false)
            } else
                this.MUXItalianCities = true;
        }
        return this.italianCities.asObservable();
    }

    GetListLKPdv(): Observable<any> {
        if (!this.pdv.getValue())
            if (this.MUXPdv) {
                this.MUXPdv = false;
                this._requestService.makeRequest('rest/internal/getListLKPdv', {},
                    (data: IListLKPdvResponse) => {
                        this.pdv.next(data.listPdv);
                    }, () => {
                        this.MUXPdv = true;
                        this.attempt++;
                        if (this.attempt < 10)
                            this.GetListLKPdv();
                    },
                    null,
                    false,
                    null,
                    100000,
                    true,
                    false)
            }
        return this.pdv.asObservable();
    }

    GetListLKMetodoPreferito(): Observable<any> {
        if (!this.metodoPreferito.getValue())
            if (this.MUXMetodoPreferito) {
                this.MUXMetodoPreferito = false;
                this._requestService.makeRequest('rest/internal/getListLKMetodoPreferito', {},
                    (data: IListLKMetodoPreferitoResponse) => {
                        this.metodoPreferito.next(data.listMethod);
                    }, () => {
                        this.attempt++;
                        this.MUXMetodoPreferito = true;
                        if (this.attempt < 10)
                            this.GetListLKMetodoPreferito();
                    },
                    null,
                    false,
                    null,
                    100000,
                    true,
                    false)
            }
        return this.metodoPreferito.asObservable();
    }
}


// WEBPACK FOOTER //
// ./src/app/theme/services/data.service.ts